<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditDealerSpecialTool</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <form [formGroup]="editSpecialToolForm" *ngIf="dealerSpecialTool" (ngSubmit)="editDealerSpecialTools()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-6 af-form-group">
                  <label for="service" translate>lblDealerName</label>
                  <div class="lbl-info">
                    <input formControlName="dealerName" class="form-control mb-2" disabled>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label for="service" translate>lblBrand</label>
                  <div class="lbl-info">
                    <select class="form-control" formControlName="brandName" disabled>
                      <option selected disabled translate [ngValue]="dealerSpecialTool.brandName">
                        {{dealerSpecialTool.brandName}}
                      </option>
                      <option *ngFor="let brand of brandList" [ngValue]="dealerSpecialTool.brandName">
                        {{brand.brandName}}
                      </option>
                    </select>
                  </div>
                </div>
                            <div class="col-6 af-form-group">
                                <label for="service" translate>lblVehicalType</label>
                                <div class="lbl-info">
                                  <input formControlName="vehicletype" class="form-control mb-2" disabled>
                                </div>
                              </div>
                <div class="col-6 af-form-group">
                  <label for="service" translate>lblPartNumber</label>
                  <div class="lbl-info">
                    <input formControlName="partNumber" class="form-control mb-2" disabled>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label for="service" translate>lblPartGroup</label>
                  <div class="lbl-info">
                    <input formControlName="partGroup" class="form-control mb-2" disabled>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label for="template-edit-image" translate>lblImage</label>
                  <div class="lbl-info">
                    <div class="custom-file">
                      <img af-image [data-code]="dealerSpecialTool.partImage" id="UploadImage" alt="image does not found." class="carimg">
                    </div>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label for="name" translate>lblDescription</label>
                  <div class='lbl-info'>
                    <input formControlName="partDescription" class="form-control mb-2"
                      [(ngModel)]="dealerSpecialTool.partDescription">
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label for="name" translate>lblQuantity <span class="required">*</span></label>
                  <div class='lbl-info'>
                    <input formControlName="totalPartQuantity" class="form-control mb-2"
                      [ngClass]="{'is-invalid': cpf.totalPartQuantity.invalid}" maxlength="20">
                    <div
                      *ngIf="cpf.totalPartQuantity.invalid && (cpf.totalPartQuantity.dirty || cpf.totalPartQuantity.touched)"
                      class="help-block mt-1 text-danger"> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      <span translate>lblTotalQuntityRequired</span>
                    </div>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label for="name" translate>lblTakeOutQuantity</label>
                  <div class='lbl-info'>
                    <input formControlName="takeoutPartQuantity" class="form-control mb-2" disabled>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label for="name" translate>lblUsedBy</label>
                  <div class='lbl-info'>
                    <input formControlName="usedBy" class="form-control mb-2" disabled>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label>&nbsp;</label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" [disabled]="!editSpecialToolForm.valid"
              translate aria-label="Center Align">lblSaveChanges</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>